import { useTranslation } from '../../i18n/LanguageContext'
import './Loader.css'

function Loader() {
  const { t } = useTranslation()
  return (
    <div className="global-loader">
      <div className="loader-content">
        <div className="loader-logo">
          <img src="/img/logo-prueba.png" alt="The UNFILTERED COLLECTIVE" />
        </div>
        <div className="loader-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <p className="loader-text">{t('common.loading')}</p>
      </div>
    </div>
  )
}

export default Loader
